import { useEffect, useState } from 'react';

/**
 * Hook to read CSS variable values from the document root.
 * Returns the parsed numeric value of a CSS variable, or a fallback if not available.
 */
export const useCSSVariable = (variableName: string, fallback: number): number => {
	const [value, setValue] = useState(fallback);

	useEffect(() => {
		if (typeof window !== 'undefined') {
			const computedValue = getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
			if (computedValue) {
				const parsed = parseFloat(computedValue);
				if (!isNaN(parsed)) {
					setValue(parsed);
				}
			}
		}
	}, [variableName]);

	return value;
};

/**
 * Hook to read CSS variable string values from the document root.
 */
export const useCSSVariableString = (variableName: string, fallback: string): string => {
	const [value, setValue] = useState(fallback);

	useEffect(() => {
		if (typeof window !== 'undefined') {
			const computedValue = getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
			if (computedValue) {
				setValue(computedValue);
			}
		}
	}, [variableName]);

	return value;
};
